export default "__VITE_ASSET__35f87a3d__"